import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CallSourceEnum, CALL_SOURCE_ENUM_LIST } from '@cbuild/enums';
import {
  CallRecords,
  CallResponseModel
} from '../../models/call-response-model';

@Component({
  selector: 'cs-call-history',
  standalone: false,
  templateUrl: './call-history.component.html',
  styleUrls: ['./call-history.component.scss']
})
export class CallHistoryComponent implements OnChanges {
  @Input()
  public data: CallResponseModel;
  public callRecordings: Array<CallRecords>;

  public ngOnChanges(changes: SimpleChanges): void {
    if ('data' in changes) {
      this.callRecordings = this.data.callRecords;
    }
  }

  public getCallSource(status: CallSourceEnum): string {
    return CALL_SOURCE_ENUM_LIST[status];
  }
}
